module.exports = __webpack_public_path__ + "static/media/bg.c3136601.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/bindCehicleActivity/image/bg.png
// module id = 418
// module chunks = 0